<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 20 20"
        :fill="color"
        xmlns="http://www.w3.org/2000/svg"
        :style="{ color }"
    >
        <path
            d="M18.0825 2.5L7.24875 13.5775L1.9175 8.1275L0 10.0875L7.24875 17.5L20 4.46125L18.0825 2.5Z"
        />
    </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
    name: 'CheckmarkSVG',
    props: {
        size: VueTypes.integer.isRequired,
        color: VueTypes.string.isRequired,
    },
};
</script>

<style></style>
